<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div
  echarts
  [options]="chartOption()"
  [loading]="loading()"
  class="treemap-chart">
</div>

